import { render, staticRenderFns } from "./GatewayListPage.vue?vue&type=template&id=6235889e&scoped=true&"
import script from "./GatewayListPage.vue?vue&type=script&lang=js&"
export * from "./GatewayListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6235889e",
  null
  
)

export default component.exports